import React, { Component } from 'react';
import { Alert, Label } from 'react-bootstrap';
import { translate } from 'react-i18next';

@translate(['common'])
export default class Notice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleMouseLeave = () => {
    // Optional: Close the alert when the user leaves the alert area
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    const { t } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        {open && (
          <div
            className="notice-hover-zone"
            style={{
              position: 'absolute',
              width: '300px',
              height: '91px',
              zIndex: '1', // Ensure this div is at a higher z-index
            }}
          />
        )}

        <Label
          onMouseOver={() => {
            this.setState({ open: true });
          }}
          onClick={() => {
            this.setState({ open: !open });
          }}
          bsStyle="warning"
          style={{
            display: 'block',
            width: '86px',
            height: '26px',
            fontSize: '14px',
            marginRight: '0px',
            textAlign: 'left',
            cursor: 'pointer',
            position: 'relative',
            zIndex: '0'
          }}
        >
          <span>
            {t('notice.notice')} &nbsp;
            <i className="fa fa-file-pdf-o" style={{ fontSize: '100%' }} />
          </span>
        </Label>

        {open && (
          <Alert
            className="notice-popup clearfix"
            bsStyle="info"
            onMouseLeave={this.handleMouseLeave}
            style={{
              position: 'absolute',
              width: '420px',
              minHeight: '120px',
              top: '0px',
              right: '0px',
              fontSize: '14px',
              zIndex: '3', // Ensure the alert appears above other content
            }}
          >
            <div
              style={{
                float: 'left',
                width: '120px',
                borderRight: '1px solid black',
                marginRight: '9px',
              }}
            >
              <b>{t('notice.server_notice')}</b> <br />
              <a
                href="/uploads/notice?serveur"
                download="notice_serveur.pdf"
                onClick={(e) => e.stopPropagation()}
              >
                {t('main.download')}
              </a>
              <br />
              <a
                href="/uploads/viewNotice?serveur"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                {t('notice.watch')}
              </a>
            </div>

            <div style={{ float: 'left', width: '120px', borderRight: '1px solid black', marginRight: '9px' }}>
              <b>{t('notice.install_notice')}</b>
              <br />
              <a
                href="/uploads/notice?install"
                download="notice_installation.pdf"
                onClick={(e) => e.stopPropagation()}
              >
                {t('main.download')}
              </a>
              <br />
              <a
                href="/uploads/viewNotice?install"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                {t('notice.watch')}
              </a>
            </div>

            <div style={{ float: 'left', width: '120px' }}>
              <b>{t('notice.cansts_notice')}</b>
              <br />
              <a
                href="/uploads/notice?cansts"
                download="notice_can_sts.pdf"
                onClick={(e) => e.stopPropagation()}
              >
                {t('main.download')}
              </a>
              <br />
              <a
                href="/uploads/viewNotice?cansts"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                {t('notice.watch')}
              </a>
            </div>
          </Alert>
        )}
      </div>
    );
  }
}
